export default {"src":"/_next/static/media/chevron-right-circle-fill.60cc62a4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};